// extracted by mini-css-extract-plugin
export var notificationHost = "_l6-0";